// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Xxtt","colBig":"styles_colBig__2dBGc","colSmall":"styles_colSmall__X8umL"};